
namespace TabAurous.OMS {
    import fld = LabourMasterRow.Fields;
    @Serenity.Decorators.registerClass()
    export class LabourMasterGrid extends Serenity.EntityGrid<LabourMasterRow, any> {
        protected getColumnsKey() { return 'OMS.LabourMaster'; }
        protected getDialogType() { return LabourMasterDialog; }
        protected getIdProperty() { return LabourMasterRow.idProperty; }
        protected getInsertPermission() { return LabourMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return LabourMasterRow.localTextPrefix; }
        protected getService() { return LabourMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.createIncludeDeletedButton();
            this.slickGrid.setOptions({ rowHeight: 30 });

        }

        getColumns() {
            let columns = super.getColumns();

            let laborType = (TabAurous.GetConfigValue(1002));

            switch (laborType) {
                case '2':

                    break;
                case '3':
                    break;
                case '4':
                    break;
                case '5':
                    break;
                case '6':
                    columns = columns.filter(x => x.field != 'CategoryName' && x.field != 'SubCategoryName'
                        && x.field != 'BrandName' && x.field != 'CollectionName');
                    break;
            }

            var PRate = Q.first(columns, x => x.field === fld.PurStdLabour);
            var SRate = Q.first(columns, x => x.field === fld.SaleStdLabour);
            var currency = new CurrencyFormatter;
            var CurrencyName = OMS.CurrencyMasterRow.getLookup().itemById[Q.Authorization.userDefinition.CurrencyId].CurrencyName;
            currency.currencyName = CurrencyName;
            PRate.format = ctx => currency.format(ctx);
            SRate.format = ctx => currency.format(ctx);


            return columns;
        }


        protected getButtons() {
            var buttons = super.getButtons();
            buttons.push({
                title: 'Import',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new Common.LabourImportExcelDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }
    }
}